<template>
  <div class="setting-checkbox-form">
    <div class="mb-20 mt-20 ml-20 mr-20">
      <div class="d-ib mr-20 ml-20 fw-b">数据权限<span v-if="isDisableSet" class="ml-20 text-999">(决定员工可查看到多少数据或内容)</span></div>
      <el-checkbox-group class="d-ib mr-20" v-model="selectDataPermissionConfigList" v-if="!isDisableSet">
        <el-checkbox class="mt-5" v-for="item in dataPermissionConfigList" :key="item.value" @change="selectDataItem($event,item.value)" :label="item.value">{{item.description}}</el-checkbox>
      </el-checkbox-group>
      <div class="ml-60" v-else>
        <div class="mt-20">
          <el-checkbox-group class="d-ib mr-20" v-model="horDataScopeListSelect">
            <el-checkbox disabled class="mt-5" v-for="item in horDataScopeList" :key="item.value" :label="item.value">{{item.description}}</el-checkbox>
          </el-checkbox-group>
        </div>
        <div class="mt-20">
          <el-checkbox-group class="d-ib mr-20" v-model="verDataScopeListSelect">
            <el-checkbox disabled class="mt-5" v-for="item in verDataScopeList" :key="item.value" :label="item.value">{{item.description}}</el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
      <div class="d-ib" v-if="!isDisableSet">
        <el-button size="mini" type="primary" @click="selectAll">全选</el-button>
        <el-button size="mini" type="primary" @click="clearAll">清空</el-button>
      </div>
    </div>
    <div class="mr-20 ml-20">
      <div :class="`bd-t bd-l bd-r h-50 lh-50 relative fw-b ${tableShow ? '' : 'bd-b'}`">
        <div class="ml-20">功能权限<span v-if="isDisableSet" class="ml-20 text-999">(决定员工可以看到哪些页面或使用哪些操作)</span></div>
        <div class="absolute right-20 top-0 text-F13736 c-pointer" @click="tableShow = tableShow ? false : true">{{tableShow ? '收起全部' : '展开全部'}}</div>
      </div>
      <el-table ref="permissionTable" :key="tablekey" style="width:100%" :span-method="objectSpanMethod" :height="tableHeight" border :data='fnPermissionsList' v-show="tableShow">
        <el-table-column label="系统" width="140" header-align="center">
          <template slot-scope="scope">
            <div>
              <el-checkbox-group v-model="systemSelectList">
                <el-checkbox :disabled="isDisableSet || item.childPermissionList.length === 0" v-for="item in scope.row.systemList" :key="item.id" :label="item.systemType" @change="selectItem($event,item,'sys')">{{item.alias}}</el-checkbox>
              </el-checkbox-group>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="模块" width="140" header-align="center">
          <template slot-scope="scope">
            <div>
              <el-checkbox-group v-model="modelSelectList">
                <el-checkbox :disabled="isDisableSet" v-for="item in scope.row.modelList" :key="item.id" :label="item.id" @change="selectItem($event,item,'model')">{{item.alias}}</el-checkbox>
              </el-checkbox-group>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="功能点" header-align="center">
          <template slot-scope="scope">
            <div>
              <el-checkbox-group v-model="fnSelectList">
                <el-checkbox :disabled="isDisableSet" v-for="item in scope.row.fnList" :key="item.id" :label="item.id" @change="selectItem($event,item)">{{item.alias}}</el-checkbox>
              </el-checkbox-group>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import {Req_GetAllPermissionConfig} from "@/request/settingInterface"
import {Req_GetSysAllPermission} from "@/request/organize"
import {
  deepClone
} from '@/util'
export default {
  data() {
    return {
      tableHeight:window.innerHeight - 350,
      tablekey:0,
      tableShow:true,
      allPermissionList:[],
      selectDataPermissionConfigList:[],
      horDataScopeListSelect:[],
      verDataScopeListSelect:[],
      horDataScopeList:[],
      verDataScopeList:[],
      dataPermissionConfigList:[],
      fnPermissionsList:[],
      systemSelectList:[],
      modelSelectList:[],
      fnSelectList:[],
      allCountObj:{},
      permissionMap:{}
    }
  },
  props:{
    dataType:{
      type:Number,
    },
    checkboxMultiple:{
      type:Boolean,
      default:false
    },
    isDisableSet:{
      type:Boolean,
      default:false
    },
    permissionList:{
      type:Array,
      default:() => {[]}
    },
    dataScopeDTO:{
      type:Object,
      default:() => {
        return {
          horDataScopeList:[],
          verDataScopeList:[]
        }
      }
    },
    permissionConfigList:{
      type:Array,
      default:() => {[]}
    }
  },
  created() {
    this.getAllPermissionConfig()
    this.getSysAllPermission()
  },
  methods: {
    emitSelectPermissions(){
      this.$emit('selectPermisions',[...this.modelSelectList,...this.fnSelectList],this.permissionMap)
    },
    handleSelectCountAddReduce(isAdd=true,pid,keyType){
      const keyList = ['sys-'+keyType,'model-'+pid]
      console.log('sys-'+keyType,'model-'+pid)
      keyList.forEach(keyItem => {
        this.allCountObj[keyItem].selectCount = this.allCountObj[keyItem].selectCount + (isAdd ? 1 : -1)
      });
    },
    //单选处理数量
    handleOnceCount(item){
      if(this.allCountObj[item.key+item.id].selectCount === this.allCountObj[item.key+item.id].allCount){
        item.list.push(item.id)
        // this.allCountObj['sys-'+item.modelSystemId].selectCount += 1
      }else{
        if(item.index !== -1){
          item.list.splice(item.index,1)
          // this.allCountObj['sys-'+item.modelSystemId].selectCount -= 1
        }
      }
      this.allCountObj['sys-'+item.modelSystemId].selectCount === this.allCountObj['sys-'+item.modelSystemId].allCount ? 
        this.systemSelectList.push(item.modelSystemId) : item.modelSystemIndex === -1 ? '' : this.systemSelectList.splice(item.modelSystemIndex,1)
    },
    //勾选模块行处理数量
    handleModelCount(sysCount,modelCount,sysId,modelId){
      this.allCountObj['sys-'+sysId].selectCount = this.allCountObj['sys-'+sysId].selectCount + sysCount
      this.allCountObj['model-'+modelId].selectCount = modelCount
    },
    handleFnSelectList(selectStatus,childPermissionList,isAddAllModelLength = false,allModelChildLength){
      childPermissionList.forEach(child => {
        const childIndex = this.fnSelectList.indexOf(child.id)
        if(isAddAllModelLength){
          allModelChildLength += 1
        }
        if(selectStatus){
          childIndex === -1 ? this.fnSelectList.push(child.id) : ''
        }else{
          childIndex !== -1 ? this.fnSelectList.splice(childIndex,1) : ''
        }
      });
      return allModelChildLength
    },
    selectItem(e,item,type){
      const keyType = type === 'sys' || type === 'model' ? item.systemType : this.permissionMap[item.pid].systemType
      if(type === 'sys'){
        const modelLength = item.childPermissionList.length
        let allModelChildLength = 0
        let handledModelLength = 0
        item.childPermissionList.forEach(sysChild => {
          const sysChildIndex = this.modelSelectList.indexOf(sysChild.id)
          e ? sysChildIndex === -1 ? this.modelSelectList.push(sysChild.id) : '' : this.modelSelectList.splice(sysChildIndex,1)
          if(sysChild.childPermissionList.length > 0){
            handledModelLength = this.handleFnSelectList(e,sysChild.childPermissionList,true,allModelChildLength)
            this.allCountObj['model-'+sysChild.id].selectCount = e ? sysChild.childPermissionList.length : 0
          }
        });
        allModelChildLength = handledModelLength
        this.allCountObj['sys-'+keyType].selectCount = e ? (modelLength + allModelChildLength) : 0
      }else if(type === 'model'){
        const systemIndex = this.systemSelectList.indexOf(item.systemType)
        console.log(this.allCountObj,item.id)
        const modelChildLength = this.allCountObj['model-'+item.id].allCount - this.allCountObj['model-'+item.id].selectCount
        this.handleFnSelectList(e,item.childPermissionList)
        this.handleModelCount(
          e ? (modelChildLength + 1) : -(item.childPermissionList.length+1),
          e ? item.childPermissionList.length : 0,
          keyType,
          item.id
        )
        if(this.allCountObj['sys-'+keyType].selectCount === this.allCountObj['sys-'+keyType].allCount){
          this.systemSelectList.push(keyType)
        }else{
          systemIndex === -1 ? '' : this.systemSelectList.splice(systemIndex,1)
        }
      }else{
        const systemIndex = this.systemSelectList.indexOf(keyType)
        const modelIndex = this.modelSelectList.indexOf(item.pid)
        this.handleSelectCountAddReduce(e,item.pid,keyType)
        const handleValue = {key:'model-',id:item.pid,list:this.modelSelectList,index:modelIndex,modelSystemId:keyType,modelSystemIndex:systemIndex}
        this.handleOnceCount(handleValue)
      }
      this.emitSelectPermissions()
    },
    handleSelectComputedChildCount(e,list,keyType,count){
      list.forEach(item => {
        count = count ? count : 1
        e ? this.allCountObj[keyType].selectCount += count : this.allCountObj[keyType].selectCount -= count
        if(item,childPermissionList){
          this.handleSelectComputedChildCount(e,item.childPermissionList,keyType,item.childPermissionList.length)
        }
      });
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }){
      if(columnIndex === 0){
        if(row.rowspan){
          return [row.rowspan,1]
        }else{
          return [0,0]
        }
      }else{
        return [1,1]
      }
    },
    //计算全选后的长度
    computedAllCount(keyType,list,allCountObj){
      list.forEach(item => {
        allCountObj.allCount += 1
        this.allCountObj['model-' + item.id] = {selectCount:0,allCount:0}
        if(item.childPermissionList.length > 0){
          this.computedAllCount('model-' + item.id,item.childPermissionList,this.allCountObj['model-' + item.id])
          this.computedAllCount(keyType,item.childPermissionList,allCountObj)
        }
      });
    },
    //计算是否已经全选并勾选系统项的选择框
    computedSelectCount(objKeyType,keyType,status){
      status ? this.allCountObj[objKeyType].selectCount += 1 : this.allCountObj[objKeyType].selectCount -= 1
      if(this.allCountObj[objKeyType].selectCount === this.allCountObj[objKeyType].allCount) {
        this.systemSelectList.push(keyType)
      }else{
        const index = this.systemSelectList.indexOf(keyType)
        index !== -1 ? this.systemSelectList.splice(index,1) : ''
      }
    },
    //处理功能权限的map
    handlePermissionMap(dataList,mapObj){
      dataList.forEach(item => {
        mapObj[item.id] = item
        if(item.childPermissionList.length > 0){
          this.handlePermissionMap(item.childPermissionList,mapObj)
        }
      });
    },
    handleComputedAllCount(type,item){
      this.allCountObj[type] = {selectCount:0,allCount:0}
      this.computedAllCount(type,item.childPermissionList,this.allCountObj[type])
    },
    //获取所有功能权限列表
    getSysAllPermission(){
      Req_GetSysAllPermission({permissionType:20}).then(res => {
        res.forEach(item => {
          this.handleComputedAllCount('sys-'+item.systemType,item)
          this.permissionMap[item.systemType] = item
          if(item.childPermissionList.length > 0){
            const newMap = {}
            this.handlePermissionMap(item.childPermissionList,newMap)
            this.permissionMap = {...this.permissionMap,...newMap}
          }
        });
        this.allPermissionList = res
        this.handlePermissionList(res)
        this.handleSelectPermisions()
      }).catch(err => {
        console.log(err)
        this.$catchErr(err)
      })
    },
    //处理回显功能权限
    handleSelectPermisions(){
      const keyObj = {
        10:'systemSelectList',
        20:'modelSelectList',
        30:'fnSelectList'
      }
      this.permissionList.forEach(item => {
        const key = keyObj[item.systemType]
        if(this.permissionMap[item.id].childPermissionList.length === item.childPermissionList.length){
          this.modelSelectList.push(item.id)
        }
        this.computedSelectCount('sys-'+item.systemType,item.systemType,true)
        if(item.childPermissionList.length > 0){
          item.childPermissionList.forEach(child => {
            this.computedSelectCount('sys-'+item.systemType,item.systemType,true)
            this.allCountObj['model-'+child.pid].selectCount += 1
            this.fnSelectList.push(child.id)
          })
        }
      });
      this.emitSelectPermissions()
    },
    //处理回显功能权限
    handlePermissionChildList(level,list,handleList){
      const keyList = {
        3:'fnList'
      }
      handleList.forEach(item => {
        // console.log(item,list,keyList,level,keyList[level],list[keyList[level]])
        list[keyList[level]].push(item)
        if(item.childPermissionList.length > 0){
          this.handlePermissionChildList(level+1,list,item.childPermissionList)
        }
      });
    },
    //处理回显功能权限
    handlePermissionList(res){
      this.fnPermissionsList = []
      res.forEach(item => {
        const resultItem = {
          systemList:[item],
          modelList:[],
          fnList:[]
        }
        if(item.childPermissionList.length > 0){
          item.childPermissionList.forEach((childItem,index) => {
            const newResultItem = deepClone(resultItem)
            if(index === 0){
              newResultItem.rowspan=item.childPermissionList.length
            }
            newResultItem.modelList.push(childItem)
            if(childItem.childPermissionList.length > 0){
              this.handlePermissionChildList(3,newResultItem,childItem.childPermissionList)
            }
            this.fnPermissionsList.push(newResultItem)
          });
        }else{
          resultItem.rowspan = 1
          this.fnPermissionsList.push(resultItem)
        }
      });
    },
    getAllPermissionConfig(){
      Req_GetAllPermissionConfig({type:this.dataType}).then(res => {
        this.horDataScopeList = res.horDataScopeList
        this.verDataScopeList = res.verDataScopeList
        this.dataPermissionConfigList = this.dataType === 30 ? res.horDataScopeList : res.verDataScopeList
        this.selectDataPermissionConfigList = this.permissionConfigList
      }).catch(err => this.$catchErr(err))
    },
    selectDataItem(state,id){
      if(!this.checkboxMultiple) {
        this.selectDataPermissionConfigList = state ? [id] : []
      }
      this.$emit('selectDataComponence',this.selectDataPermissionConfigList)
    },
    selectAllFnList(state,list,mapList){
      list = mapList.map(item => {
        return item.id
      })
      return list
    },
    handleSelectSystem(){
      this.fnPermissionsList.forEach(item => {
        if(this.systemSelectList.indexOf(item.systemList[0].systemType) === -1){
          this.systemSelectList.push(item.systemList[0].systemType)
        }
      })
    },
    handleSelectAllComputedCount(isZero=false){
      for (const key in this.allCountObj) {
        this.allCountObj[key].selectCount = isZero ? 0 : this.allCountObj[key].allCount
      }
    },
    initSelectList(otherList = []){
      let listKey = ['modelSelectList','fnSelectList','systemSelectList',...otherList]
      listKey.forEach(keyItem => {
        this[keyItem] = []
      });
    },
    selectAll(){
      this.selectDataPermissionConfigList = this.dataType === 30 ? [10,20,30,40,50] : [10]
      let newAllFnList = []
      this.initSelectList()
      this.handleSelectSystem()
      this.fnPermissionsList.forEach(item => {
        let systemList,
            modelList,
            fnList = []
        modelList = this.selectAllFnList(true,modelList,item.modelList)
        fnList = this.selectAllFnList(true,fnList,item.fnList)
        this.modelSelectList = [...this.modelSelectList,...modelList]
        this.fnSelectList = [...this.fnSelectList,...fnList]
      });
      this.$emit('selectDataComponence',this.selectDataPermissionConfigList)
      this.emitSelectPermissions()
      this.handleSelectAllComputedCount()
    },
    initChangeData(nV){
      if(this.isDisableSet === true){
        this.horDataScopeListSelect = []
        this.dataScopeDTO.horDataScopeList.forEach(item => {
          this.horDataScopeListSelect.push(item.value)
        });
        this.dataScopeDTO.verDataScopeList[0] ? this.verDataScopeListSelect = [this.dataScopeDTO.verDataScopeList[0].value] : this.verDataScopeListSelect = ''
      }else{
        this.selectDataPermissionConfigList = this.permissionConfigList
      }
      this.initSelectList()
      this.allCountObj = {}
      this.allPermissionList.forEach(item => {
        this.handleComputedAllCount('sys-'+item.systemType,item)
      });
      this.handlePermissionList(this.allPermissionList)
      this.handleSelectPermisions()
    },
    clearAll(){
      this.handleSelectAllComputedCount(true)
      this.initSelectList(['selectDataPermissionConfigList'])
      this.$emit('selectDataComponence',this.selectDataPermissionConfigList)
      this.emitSelectPermissions()
    }
  },
  computed:{

  },
  watch:{
    permissionList(nV){
      this.initChangeData(nV)
    }
  },
  components:{

  }
}
</script>

<style lang="scss">

</style>


// WEBPACK FOOTER //
// src/components/Setting/SettingCheckboxForm.vue